import type { State } from '../../Slice/index.js'
import { useSelector } from 'react-redux'

export const selectInvites = (state: typeof State) => state.invitation.invites
export const useInvites = () => useSelector(selectInvites)

export const selectCurrentInvite = (state: typeof State) => state.invitation.currentInvite
export const useCurrentInvite = () => useSelector(selectCurrentInvite)
